/**
 * FROZN — Product Page JS
 * Covers: gallery, variant cards, nutrition switcher,
 *         sticky ATC, accordions, email capture.
 * No framework dependencies. Compatible with GA4, Meta Pixel, Clarity.
 */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────── */
  function qs(root, sel)  { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  /* ── 1. Gallery ──────────────────────────────────────── */
  function initGallery(root) {
    var slides = qsa(root, '.frozn-pdp__slide');
    var thumbs = qsa(root, '.frozn-pdp__thumb');
    if (!thumbs.length || !slides.length) return;

    function activate(mediaId) {
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.mediaId === mediaId);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === mediaId);
        t.setAttribute('aria-pressed', t.dataset.mediaId === mediaId ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn.dataset.mediaId); });
    });
  }

  /* ── 2a. Promo preview config ─────────────────────────
     Display-only. Shopify's /discount/CODE link applies the real discount.
     Add/remove codes here only. Value = percent off product subtotal. */
  var FROZN_PROMOS = {
    LAUNCH: 10,
    TIKTOK10: 10,
    INSTA10: 10
  };
  var PROMO_STORE_KEY = 'frozn_promo';
  var PROMO_REJECTED_KEY = 'frozn_promo_rejected';

  function isRejected(code) {
    try { return window.sessionStorage.getItem(PROMO_REJECTED_KEY) === code; } catch (e) { return false; }
  }

  function hasOwn(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function validPct(p) { return typeof p === 'number' && isFinite(p) && p > 0 && p < 100; }

  function detectPromo() {
    try {
      var code = null;
      var raw = new URLSearchParams(window.location.search).get('promo');
      if (raw) {
        var c = String(raw).trim().toUpperCase();
        if (/^[A-Z0-9_-]{1,32}$/.test(c) && hasOwn(FROZN_PROMOS, c) && validPct(FROZN_PROMOS[c])) code = c;
      }
      if (!code) {
        var stored = null;
        try { stored = window.sessionStorage.getItem(PROMO_STORE_KEY); } catch (e) {}
        if (stored && hasOwn(FROZN_PROMOS, stored) && validPct(FROZN_PROMOS[stored])) code = stored;
      }
      if (!code || isRejected(code)) return null;
      try { window.sessionStorage.setItem(PROMO_STORE_KEY, code); } catch (e) {}
      return { code: code, pct: FROZN_PROMOS[code] };
    } catch (e) { return null; }
  }

  function formatGBP(pence) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pence / 100);
    } catch (e) {
      return '\u00A3' + (pence / 100).toFixed(2);
    }
  }

  /* Returns true only if every card was updated. On any problem, nothing changes. */
  function applyPromo(root, cards, promo) {
    if (!promo) return false;
    try {
      var plan = cards.map(function (card) {
        var cents = parseInt(card.dataset.variantPriceRaw, 10);
        var pouches = parseInt(card.dataset.pouchCount, 10);
        var box = qs(card, '.frozn-pdp__vcard-box');
        var boxVal = qs(card, '.frozn-pdp__vcard-box-val');
        if (!isFinite(cents) || cents <= 0 || !isFinite(pouches) || pouches <= 0 || !box || !boxVal) throw new Error('promo: bad data');
        var promoCents = Math.round(cents * (100 - promo.pct) / 100);
        if (!(promoCents > 0 && promoCents < cents)) throw new Error('promo: bad maths');
        return { card: card, box: box, boxVal: boxVal, promoCents: promoCents };
      });
      plan.forEach(function (p) {
        var row = document.createElement('div');
        row.className = 'frozn-pdp__vcard-boxrow';
        var was = document.createElement('s');
        was.className = 'frozn-pdp__vcard-was';
        was.textContent = p.card.dataset.variantPrice;
        p.box.parentNode.insertBefore(row, p.box);
        row.appendChild(was);
        row.appendChild(p.box);
        p.boxVal.textContent = formatGBP(p.promoCents);
        p.card.dataset.promoPrice = formatGBP(p.promoCents);
      });
      var label = qs(root, '.frozn-pdp__variant-label');
      if (label) {
        var note = document.createElement('p');
        note.className = 'frozn-pdp__promo-note';
        var tag = document.createElement('span');
        tag.textContent = promo.code + ' offer \u2014 ' + promo.pct + '% off*';
        note.appendChild(tag);
        label.parentNode.insertBefore(note, label.nextSibling);
      }
      root.dataset.promo = promo.code;
      root.classList.add('frozn-pdp--promo');
      return true;
    } catch (e) {
      return false;
    }
  }

  /* ── 2b. Apply promo to the Shopify cart on Add to Cart ──
     Only attached when a recognised promo is active.
     1. POST {root}cart/add.js   — same form fields as the normal submit
     2. GET  {root}cart.js       — read codes already on the cart
     3. POST {root}cart/update.js { discount: "EXISTING,CODE" } — Shopify validates
     4. Go to {root}cart, exactly where the normal form submit lands.
     If step 1 fails, the form is submitted natively (normal behaviour).
     If steps 2–3 fail, the item is still in the cart at Shopify's normal price. */
  function cartUrl(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + path;
  }

  function bindPromoCart(form, promo) {
    if (!form || !window.fetch || !window.FormData) return;
    var busy = false;

    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      e.preventDefault();
      busy = true;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      function nativeSubmit() {
        busy = false;
        if (btn) btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      }
      function goToCart() { window.location.href = cartUrl('cart'); }

      fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          return fetch(cartUrl('cart.js'), { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; })
            .then(function (cart) {
              var codes = [];
              if (cart && Array.isArray(cart.discount_codes)) {
                cart.discount_codes.forEach(function (d) {
                  if (d && d.code && String(d.code).toUpperCase() !== promo.code) codes.push(d.code);
                });
              }
              codes.push(promo.code);
              return fetch(cartUrl('cart/update.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ discount: codes.join(',') })
              });
            })
            .then(function (r) { return r && r.ok ? r.json() : null; })
            .then(function (cart) {
              try {
                var hit = cart && Array.isArray(cart.discount_codes) && cart.discount_codes.find(function (d) {
                  return d && String(d.code).toUpperCase() === promo.code;
                });
                if (hit && hit.applicable === false) {
                  window.sessionStorage.setItem(PROMO_REJECTED_KEY, promo.code);
                  window.sessionStorage.removeItem(PROMO_STORE_KEY);
                }
              } catch (err) {}
            })
            .catch(function () {})
            .then(goToCart);
        }, nativeSubmit);
    });
  }

  /* ── 2. Variant cards ────────────────────────────────── */
  function initVariantCards(root, sectionId) {
    var cards = qsa(root, '.frozn-pdp__vcard');
    if (!cards.length) return;

    var mainInput    = document.getElementById('frozn-vid-' + sectionId);
    var stickyInput  = document.getElementById('frozn-sticky-vid-' + sectionId);
    var priceEl      = qs(root, '.frozn-pdp__price-val');
    var stickyPrice  = document.getElementById('frozn-sticky-price-' + sectionId);
    var atcBtn       = qs(root, '.frozn-pdp__atc');

    var deliveredMode = !!(atcBtn && atcBtn.classList.contains('frozn-pdp__atc--delivered'));
    var promo = detectPromo();
    var promoActive = deliveredMode && applyPromo(root, cards, promo);
    if (promoActive) {
      bindPromoCart(atcBtn && atcBtn.closest('form'), promo);
      bindPromoCart(document.getElementById('frozn-sticky-form-' + sectionId), promo);
    }
    if (promoActive && atcBtn) {
      try {
        var form = atcBtn.closest('form') || atcBtn;
        var terms = document.createElement('p');
        terms.className = 'frozn-pdp__promo-terms';
        terms.textContent = '*With valid ' + promo.code + ' code \u00B7 one use per customer';
        form.parentNode.insertBefore(terms, form.nextSibling);
      } catch (e) {}
    }

    function displayPrice(card) {
      return (promoActive && card.dataset.promoPrice) ? card.dataset.promoPrice : card.dataset.variantPrice;
    }

    function renderPrice(card) {
      var price = displayPrice(card);
      var avail = card.dataset.variantAvailable !== 'false';
      var fee = card.dataset.deliveryFee;
      if (priceEl)     priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (!atcBtn) return;
      var label = atcBtn.dataset.atcLabel || 'Add to Cart';
      atcBtn.disabled = !avail;
      if (!avail) {
        atcBtn.textContent = 'Sold Out';
      } else if (deliveredMode) {
        atcBtn.innerHTML = '';
        var main = document.createElement('span');
        main.className = 'frozn-pdp__atc-main';
        main.textContent = label + ' \u2014 ' + price + (promoActive && card.dataset.promoPrice ? '*' : '');
        var sub = document.createElement('span');
        sub.className = 'frozn-pdp__atc-sub';
        sub.textContent = fee ? '+ ' + fee + ' frozen delivery' : 'Free frozen delivery';
        atcBtn.appendChild(main);
        atcBtn.appendChild(sub);
      } else {
        atcBtn.textContent = label + ' \u2014 ' + price;
      }
    }

    function selectCard(card) {
      var vid = card.dataset.variantId;

      cards.forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');

      if (mainInput)   mainInput.value   = vid;
      if (stickyInput) stickyInput.value = vid;
      renderPrice(card);

      /* URL update — only touches ?variant=, keeps promo/UTM params */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', vid);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      /* GA4 */
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: { items: [{ item_id: vid, item_name: document.title }] }
        });
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
    });

    /* Promo: refresh the button for the server-rendered active card (no tracking events) */
    if (promoActive) {
      var active = cards.find(function (c) { return c.classList.contains('is-active'); });
      if (active) renderPrice(active);
    }

    /* Pre-select variant from URL */
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('variant');
    if (urlVariant) {
      var match = cards.find(function (c) { return c.dataset.variantId === urlVariant; });
      if (match) selectCard(match);
    } else {
      var urlPack = urlParams.get('pack');
      if (urlPack) {
        var packMatch = cards.find(function (c) {
          return c.dataset.pouchCount === urlPack && c.dataset.variantAvailable !== 'false';
        });
        if (packMatch) selectCard(packMatch);
      }
    }
  }

  /* ── 3. Nutrition patty switcher ─────────────────────── */
  function initNutrition(root) {
    var block = qs(root, '[data-frozn-nutrition]');
    if (!block) return;

    var btns = qsa(block, '.frozn-pdp__patty-btn');
    var nums = qsa(block, '[data-nutri-base]');

    function update(count) {
      btns.forEach(function (b) {
        var active = parseInt(b.dataset.patty, 10) === count;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      nums.forEach(function (el) {
        var base   = parseFloat(el.dataset.nutriBase);
        var suffix = el.dataset.nutriSuffix || '';
        var dp     = el.dataset.nutriDp !== undefined ? parseInt(el.dataset.nutriDp, 10) : 1;
        var val    = base * count;
        el.textContent = (suffix === '' ? Math.round(val) : val.toFixed(dp)) + suffix;
      });
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        update(parseInt(btn.dataset.patty, 10));
      });
    });
  }

  /* ── 4. Sticky ATC ───────────────────────────────────── */
  function initStickyATC(root, sectionId) {
    var bar  = document.getElementById('frozn-sticky-bar-' + sectionId);
    var hero = qs(root, '.frozn-pdp__info');
    if (!bar || !hero) return;

    function check() {
      var shown = hero.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ── 5. Accordions (details + FAQ) ──────────────────── */
  function initAccordions(root) {
    qsa(root, '[data-accordion-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var bodyId = btn.getAttribute('aria-controls');
        var body   = bodyId ? document.getElementById(bodyId) : null;
        var icon   = qs(btn, '[data-icon]');

        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (body)  body.classList.toggle('is-open', !isOpen);
        if (icon)  icon.textContent = isOpen ? '+' : '−';
      });
    });
  }

  /* ── 6. Email capture (real Shopify customer form, AJAX submit) ── */
  function initEmail(root) {
    var wrap    = qs(root, '[data-email-wrap]');
    var form    = qs(root, '.frozn-pdp__pl-form');
    var input   = qs(root, '[data-email-input]');
    var btn     = qs(root, '[data-email-btn]');
    var success = qs(root, '[data-email-success]');
    var errorEl = qs(root, '[data-email-error]');
    var returnToField = form ? form.querySelector('input[name="return_to"]') : null;
    if (!form || !wrap || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (!input || !input.checkValidity()) {
        if (input) input.reportValidity();
        return;
      }

      /* Keep return_to accurate for any preview/template query params,
         in case JS fails and the browser falls back to a native submit. */
      if (returnToField) {
        returnToField.value = window.location.pathname + window.location.search + '#frozn-pdp-early-access-form';
      }

      btn.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' }
      })
        .then(function (response) {
          btn.disabled = false;
          if (!response.ok) throw new Error('Request failed');

          wrap.hidden = true;
          if (success) success.hidden = false;

          if (window.dataLayer) {
            window.dataLayer.push({ event: 'frozn_email_signup', email: input.value });
          }
        })
        .catch(function () {
          btn.disabled = false;
          if (errorEl) errorEl.hidden = false;
        });
    });
  }

  /* ── Init all product sections ───────────────────────── */
  function init() {
    qsa(document, '[id^="frozn-pdp-"]').forEach(function (root) {
      var sectionId = root.id.replace('frozn-pdp-', '');
      initGallery(root);
      initVariantCards(root, sectionId);
      initNutrition(root);
      initStickyATC(root, sectionId);
      initAccordions(root);
      initEmail(root);
    });

    /* Accordion-only sections (details, FAQ, etc.) */
    qsa(document, '[data-frozn-accordion-root]').forEach(function (root) {
      initAccordions(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
